export default __webpack_public_path__ + "static/media/1826.174d06bd.png";